<template>
 
  <section class="subscribe-bg">
    <div class="container">
      <div class="row">
        <div class="col-sm-12 col-lg-4">
          <div class="subscribe">
            <h3>اشترك في النشرة الإخبارية</h3>
          </div>
        </div>
        <div class="col-sm-12 col-lg-8">
          <div class="email-box">
            <form>
              <input type="email" class="form-control" id="exampleInputEmail1"
                     placeholder="أدخل بريدك الإلكتروني">
              <button type="submit" class="btn btn-email">الاشتراك</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>
<script>
export default {
  name: 'Subscribe'
}
</script>
